import { Vue, Component, Prop } from 'vue-property-decorator'
import ModalBase from '@/components/modalBase/modalBase'

@Component({
  components: {
    ModalBase
  }
})
export default class ModalOkCancel extends Vue {
  @Prop({ default: false }) show;
  @Prop({ default: true }) closeButton;
  @Prop({ default: "" }) okButtonMessage;
  @Prop({ default: "" }) cancelButtonMessage;
  @Prop({ default: "" }) title;
  @Prop({ default: "" }) content;
  @Prop({ default: "" }) imgSrc;

  get getShowModal() {
    let response = false;
    if((this.title || this.content) && this.show) {
      response = true;
    }
    return response;
  }

  _onAccept() {
    this.$emit('accept');
  }

  _onCancel() {
    this.$emit('cancel');
  }

  _onCloseModal() {
    this.$emit('close');
  }
}